"use client";

const counterData = [
  { title: "Industry & Skilling Partners", number: 650 },
  { title: "Sectors Covered", number: 30 },
  { title: "Central Ministries & State Government Partners", number: 20 },
  { title: "CSR Partners", number: 20 },
  { title: "Defence Partners", number: 10 },
];

const CounterSection = () => {
  return (
    <section className="
        w-full text-white heading_space_bottom
        grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5
        gap-4 md:gap-0 text-center"
    >
      {counterData.map((item, index) => (
        <div
          key={index}
          className="relative flex flex-col justify-center items-center gap-0 md:gap-2 px-4"
        >
          {index !== counterData.length - 1 && (
            <div className="hidden lg:block absolute right-0 top-1/2 -translate-y-1/2 h-full w-[1px] bg-[#27506C]"></div>
          )}

          <p className="text-[25px] sm:text-[25px] md:text-[48px] lg:text-[54px] font-bold text-[#FFA201]">
            {item.number}+
          </p>

          <p className="text-[16px] leading-6 ">{item.title}</p>
        </div>
      ))}
    </section>
  );
};

export default CounterSection;
